export default __webpack_public_path__ + "static/media/GR10 10A-2EC.b5854c2e.jpg";